import { Component, OnInit, Inject, ElementRef, ViewChild } from "@angular/core";
import { CommonVariable } from "src/app/app.constants";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { FormControl, Validators } from "@angular/forms";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
import { NgClass } from "@angular/common";
@Component({
    selector: "app-edit-mobile-number",
    templateUrl: "./edit-mobile-number.component.html",
    styleUrls: ["./edit-mobile-number.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        NgClass,
        TranslatePipe,
    ],
})
export class EditMobileNumberComponent implements OnInit {
  msn: any;
  countryCode: any;
  isNumberInvalid = false;
  @ViewChild("phoneNumber", { static: true }) phoneNumber: ElementRef;
  cell1TelInput = {
    initialCountry: CommonVariable.countryCode,
    separateDialCode: false,
  };
  mobileNumberFromControl = new FormControl("", [Validators.required]);
  phoneInValid: boolean = true;
  selectedData = {
    iso2: "",
    number: "",
    dialCode: "",
  };
  constructor(
    private bottomSheetRef: MatBottomSheetRef<EditMobileNumberComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private authService: AuthService,
    public translate: TranslateService
  ) {
    try{
      this.authService?.selectedlanguage$?.subscribe((l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      }, err => { return (err) });
  
    } catch(e){

    }

  }

  ngOnInit() { }

  numericOnly(event): boolean {
    const charcode = event.which ? event.which : event.keyCode;
    if (charcode >= 48 && charcode <= 57) {
      return true;
    }
    return false;
  }

  getPhoneNumber(phNumber) {
    try{
      this.mobileNumberFromControl.setValue(phNumber);
      this.msn = phNumber?.substring(phNumber.length - 10);
      this.countryCode = phNumber?.split(this.msn)[0]?.split("+")[1];
    } catch(e){
      console.log(e);
    }

  }

  phoneNumberHasError(hasError: boolean) {
    this.isNumberInvalid = !hasError;
    this.phoneInValid = this.phoneNumber.nativeElement.value ? true : false;
  }

  back() {
    this.bottomSheetRef.dismiss()
  }

  updateMobileNumber() {
    this.bottomSheetRef.dismiss(this.selectedData);
  }
  getAllSelected(event) {
    this.selectedData.iso2 = event.iso2;
    this.selectedData.dialCode = "+" + event.dialCode;
  }
  
  flagsDropdownToggle(value: boolean) {
 
    CommonVariable.flagsDropdownOpened = value;
  }
}
